export default __webpack_public_path__ + "static/media/solarimg3.f24fe50b.png";